/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";

import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetClientConfigParamsQueryVariables = Types.Exact<{
  input: Types.ConfigParamsInput;
}>;

export type GetClientConfigParamsQuery = {
  __typename?: "Query";
  client?: {
    __typename?: "Client";
    id: string;
    businessLine: Types.BusinessLine;
    configParams: Array<{ __typename?: "ConfigParam"; name: string; value: string }>;
    capabilities: { __typename?: "ClientCapabilities"; canShop: boolean; canScheduleFix: boolean };
  } | null;
};

export const GetClientConfigParamsDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "getClientConfigParams" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: { kind: "Variable", name: { kind: "Name", value: "input" } },
          type: {
            kind: "NonNullType",
            type: { kind: "NamedType", name: { kind: "Name", value: "ConfigParamsInput" } },
          },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "client" },
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                { kind: "Field", name: { kind: "Name", value: "id" } },
                { kind: "Field", name: { kind: "Name", value: "businessLine" } },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "configParams" },
                  arguments: [
                    {
                      kind: "Argument",
                      name: { kind: "Name", value: "input" },
                      value: { kind: "Variable", name: { kind: "Name", value: "input" } },
                    },
                  ],
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "name" } },
                      { kind: "Field", name: { kind: "Name", value: "value" } },
                    ],
                  },
                },
                {
                  kind: "Field",
                  name: { kind: "Name", value: "capabilities" },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      { kind: "Field", name: { kind: "Name", value: "canShop" } },
                      { kind: "Field", name: { kind: "Name", value: "canScheduleFix" } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetClientConfigParamsQuery__
 *
 * To run a query within a React component, call `useGetClientConfigParamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientConfigParamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientConfigParamsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetClientConfigParamsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetClientConfigParamsQuery,
    GetClientConfigParamsQueryVariables
  > &
    ({ variables: GetClientConfigParamsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetClientConfigParamsQuery, GetClientConfigParamsQueryVariables>(
    GetClientConfigParamsDocument,
    options,
  );
}
export function useGetClientConfigParamsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetClientConfigParamsQuery,
    GetClientConfigParamsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetClientConfigParamsQuery, GetClientConfigParamsQueryVariables>(
    GetClientConfigParamsDocument,
    options,
  );
}
// @ts-ignore
export function useGetClientConfigParamsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetClientConfigParamsQuery,
    GetClientConfigParamsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<GetClientConfigParamsQuery, GetClientConfigParamsQueryVariables>;
export function useGetClientConfigParamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClientConfigParamsQuery,
        GetClientConfigParamsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  GetClientConfigParamsQuery | undefined,
  GetClientConfigParamsQueryVariables
>;
export function useGetClientConfigParamsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetClientConfigParamsQuery,
        GetClientConfigParamsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetClientConfigParamsQuery, GetClientConfigParamsQueryVariables>(
    GetClientConfigParamsDocument,
    options,
  );
}
export type GetClientConfigParamsQueryHookResult = ReturnType<typeof useGetClientConfigParamsQuery>;
export type GetClientConfigParamsLazyQueryHookResult = ReturnType<
  typeof useGetClientConfigParamsLazyQuery
>;
export type GetClientConfigParamsSuspenseQueryHookResult = ReturnType<
  typeof useGetClientConfigParamsSuspenseQuery
>;
export type GetClientConfigParamsQueryResult = Apollo.QueryResult<
  GetClientConfigParamsQuery,
  GetClientConfigParamsQueryVariables
>;
